import { IsDefined, IsNumber } from 'class-validator';

export class Timestamp {
  @IsNumber()
  @IsDefined()
  timestamp: number;

  @IsNumber()
  @IsDefined()
  value: number;
}
